import { useMemo } from 'react';

import { useMatchesCalendarStore } from '../store';

export const useFilters = () => {
  const filters = useMatchesCalendarStore((state) => state.filters);
  const setFilters = useMatchesCalendarStore((state) => state.setFilters);
  const filtersActive = useMemo(() => filters && Object.values(filters).some(Boolean), [filters]);

  return { filters, filtersActive, setFilters };
};
